/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Sleva`
};

const da_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Rabat`
};

const de_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatt`
};

const en_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Discount`
};

const es_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Descuento`
};

const fr_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Remise`
};

const hu_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Kedvezmény`
};

const it_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Sconto`
};

const nl_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Korting`
};

const pl_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Rabat`
};

const pt_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Desconto`
};

const sv_discount = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const discount = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount", locale)
	if (locale === "cs") return cs_discount(inputs)
	if (locale === "da") return da_discount(inputs)
	if (locale === "de") return de_discount(inputs)
	if (locale === "en") return en_discount(inputs)
	if (locale === "es") return es_discount(inputs)
	if (locale === "fr") return fr_discount(inputs)
	if (locale === "hu") return hu_discount(inputs)
	if (locale === "it") return it_discount(inputs)
	if (locale === "nl") return nl_discount(inputs)
	if (locale === "pl") return pl_discount(inputs)
	if (locale === "pt") return pt_discount(inputs)
	return sv_discount(inputs)
};